class SearchResults {
    init () {
        $('.serviceMenu .questionItem .questionIconDown').on('click', (event) => {
            this.toggleContent(event.target);
            $(event.target).closest('.questionIconDown').toggleClass('hidden');
        });

        $('.serviceMenu .questionItem .questionIconUp').on('click', (event) => {
            this.toggleContent(event.target);
            $(event.target).closest('.questionItem').children('.questionIconDown').toggleClass('hidden');
        });
    }

    toggleContent(elment) {
        $(elment).closest('.questionItem').children('.content').slideToggle();
    }
}

$(document).ready(() => {
    let searchResults = new SearchResults();
    searchResults.init();
});
